import { render, staticRenderFns } from "./DragSelect.vue?vue&type=template&id=795425b3&"
import script from "./DragSelect.vue?vue&type=script&lang=js&"
export * from "./DragSelect.vue?vue&type=script&lang=js&"
import style0 from "./DragSelect.vue?vue&type=style&index=0&id=795425b3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports